import PropTypes from 'prop-types';
import Backdrop from '../Backdrop/Backdrop';
import classes from './Modal.module.css';

const Modal = ({ children, show, onClose, closeWithBackdrop }) =>
  show && (
    <>
      <Backdrop show={show} onClose={closeWithBackdrop ? onClose : undefined} />
      <div data-testid="modal" className={classes.modal}>
        {children}
      </div>
    </>
  );

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  closeWithBackdrop: PropTypes.bool,
};

Modal.defaultProps = {
  onClose: () => {},
  closeWithBackdrop: true,
};

export default Modal;
